<template>
  <div class="el-input pinyin-input">
    <el-popover placement="bottom-start" trigger="focus" v-model="visible" :disabled="disabled">
      <el-input slot="reference" :type="type" :value="nativePinyin" :placeholder="placeholder" :readonly="readonly"
      @input="handleInput" @focus="showTones"
      :autosize="autosize" :resize="resize"></el-input>
      <div class="tone-word-list">
        <div class="item" v-for="(item, index) in multiToneItems" :key="index">
          <span>{{item.text}}</span>
          <el-radio v-model="tones[item.index]" v-for="(p, n) in item.items" :key="n" :label="n">{{p}}</el-radio>
        </div>
      </div>
      <div style="text-align: right; margin: 0">
        <el-button size="mini" type="text" @click="visible = false">取消</el-button>
        <el-button type="primary" size="mini" @click="handleToneConfirm">确定</el-button>
      </div>
    </el-popover>
  </div>
</template>

<script>
import pinyin from 'pinyin'
export default {
  name: 'PinyinInput',
  props: {
    type: String,
    text: String,
    value: String,
    resize: String,
    placeholder: String,
    readonly: {
      type: Boolean,
      default: false
    },
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    autocase: {
      type: Boolean,
      default: true
    },
    uppercase: {
      type: Boolean,
      default: true
    },
    closetips: Boolean
  },
  data () {
    return {
      nativeText: '',
      nativePinyin: '',
      adjustPinyin: true,
      toneText: null,
      toneItems: [],
      multiToneItems: [],
      tones: {},
      visible: false
    }
  },
  watch: {
    value: {
      handler () {
        if (this.nativePinyin !== this.value) {
          this.nativeText = this.text
          this.nativePinyin = this.value
          this.adjustPinyin = !this.value || this.value === this.getTextPinyin(this.text)
        }
      },
      immediate: true
    },
    text: {
      handler () {
        //文本改变时重置拼音
        if (this.autocase && this.adjustPinyin && this.text !== this.nativeText) {
          this.updateTextPinyin()
        }
      },
      immediate: true
    },
    uppercase () {
      //大小写改变时重置拼音
      this.adjustPinyin && this.updateTextPinyin()
    }
  },
  computed: {
    disabled () {
      return this.closetips || this.multiToneItems.length === 0
    }
  },
  methods: {
    handleInput (val) {
      this.nativePinyin = val
      this.adjustPinyin = !val || val === this.getTextPinyin(this.text)
      this.$emit('input', val)
    },
    getPinyin (text) {
      let ps = pinyin(this.getLowerSymbol(text), { heteronym: true })
      if (this.uppercase) {
        ps[0] = ps[0].map(n => {
          return n.slice(0, 1).toUpperCase() + n.slice(1)
        })
      }
      return ps.map(n => n.join('|')).join('')
    },
    getTextPinyin (text) {
      if (!text) return ''
      let items = this.text.split(/\r\n|\n/)
      if (items.length === 1) {
        return this.getPinyin(this.text)
      } else {
        return items.map(n => this.getPinyin(n)).join(`\n`)
      }
    },
    getLowerSymbol(text) {
      return text.replace('。', '.').replace('？', '?').replace('！', '!')
    },
    updateTextPinyin () {
      this.nativeText = this.text
      this.nativePinyin = this.getTextPinyin(this.text)
      this.$emit('input', this.nativePinyin)
    },
    showTones () {
      if (this.text === this.toneText || !this.text){
        this.visible = true
        return
      }
      this.toneText = this.text
      let items = []
      let list = []
      this.getLowerSymbol(this.toneText).match(/[\u4e00-\u9fa5]+/g).forEach((hz, index) => {
        let ps = pinyin(hz, { heteronym: true })
        if (index === 0 && this.uppercase && this.toneText.startsWith(hz)) {
          ps[0] = ps[0].map(n => {
            return n.slice(0, 1).toUpperCase() + n.slice(1)
          })
        }
        ps.forEach((p, i) => {
          if (p.length > 1) {
            list.push({
              index: items.length,
              text: hz.substr(i, 1),
              items: p
            })
          }
          items.push(p)
        })
      })
      this.toneItems = items
      this.multiToneItems = list
      this.visible = true
    },
    handleToneConfirm () {
      let pos = 0
      this.nativePinyin = this.getLowerSymbol(this.toneText).replace(/[\u4e00-\u9fa5]+/g, m => {
        let ps = []
        for(let i = 0, c = m.length; i < c; i++, pos++){
          if (pos in this.tones) {
            ps.push(this.toneItems[pos][this.tones[pos]])
          } else {
            ps.push(this.toneItems[pos][0])
          }
        }
        return ps.join('')
      })
      this.visible = false
      this.$emit('input', this.nativePinyin)
    }
  }
}
</script>

<style lang="scss">
.pinyin-input{
  .el-input-group{
    vertical-align: baseline;
  }
}
.tone-word-list{
  font-size: 16px;
  margin-bottom: 12px;
  max-height: 213px;
  overflow-y: auto;
  .item{
    + .item{
      margin-top: 3px;
    }
    >span{
      display: inline-block;
      width: 30px;
    }
    >.el-radio{
      width: 70px;
      font-size: 16px;
    }
    .el-radio__label{
      font-size: 16px;
    }
  }
}
</style>
